// Orquestador de montaje del Analizador Cabrillo nativo.
// Junta los módulos de render sobre un motor ya cargado (ver motor.js).
// No calcula nada analítico (eso es motor.js/modelo.js) ni conoce
// Drive/Firestore/selector de concursos (eso es cabrillo-logs.js y la
// página que lo use). Ver src/cabrillo/CREDITOS.md.

import { montar as montarEncabezado } from './render/render-encabezado.js';
import { montar as montarControles } from './render/render-controles.js';
import { montar as montarTimeline } from './render/render-timeline.js';
import { montar as montarMapa } from './render/render-mapa.js';
import { montar as montarRitmo } from './render/render-ritmo.js';
import { montar as montarEstadisticas } from './render/render-estadisticas.js';

/**
 * @param {object} els - referencias a los elementos DOM del analizador
 *   (ver cabrillo-analizador.html para los ids exactos)
 * @param {ReturnType<import('./motor.js').crearAnalizador>} motor
 * @returns {{actualizarTodos: Function, destruir: Function}}
 */
export function montarAnalizador(els, motor) {
    const modulos = [
        montarEncabezado({ titulo: els.titulo, sub: els.sub }, motor),
        montarControles({ play: els.play, all: els.all, spd: els.spd, clock: els.clock, sl: els.sl, bf: els.bf, mini: els.mini }, motor),
        montarTimeline({ cv: els.cv, leg: els.leg }, motor),
        montarMapa({ mp: els.mp, tt: els.tt, md: els.md, ml: els.ml }, motor),
        montarRitmo({ rt: els.rt, kp: els.kp }, motor),
        montarEstadisticas({ mx: els.mx, tc: els.tc, tz: els.tz }, motor),
    ];

    function actualizarTodos() {
        modulos.forEach((m) => m.actualizar());
    }

    // Atajos de teclado y listeners globales: igual comportamiento que el
    // original (plantilla.html:121,139), pero llamando al motor en vez de
    // a funciones/variables globales. Como ya no vivimos en un iframe
    // aislado, se registran sobre document/window de la página real.
    function onKeydown(e) {
        if (/INPUT|SELECT|TEXTAREA|BUTTON/.test(e.target.tagName)) return;
        if (e.key === ' ') {
            e.preventDefault();
            if (motor.estaReproduciendo()) motor.pausar();
            else motor.reproducir();
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            motor.pausar();
            motor.avanzar((e.key === 'ArrowRight' ? 1 : -1) * (e.shiftKey ? 6 : 1));
        }
    }
    function onResize() {
        actualizarTodos();
    }
    function onThemeChange() {
        actualizarTodos();
    }

    document.addEventListener('keydown', onKeydown);
    window.addEventListener('resize', onResize);
    const mqTema = matchMedia('(prefers-color-scheme: dark)');
    mqTema.addEventListener('change', onThemeChange);

    function destruir() {
        document.removeEventListener('keydown', onKeydown);
        window.removeEventListener('resize', onResize);
        mqTema.removeEventListener('change', onThemeChange);
        modulos.forEach((m) => m.destruir?.());
    }

    return { actualizarTodos, destruir };
}
